import { render } from "./Fourcards.vue?vue&type=template&id=bce5def6&scoped=true"
import script from "./Fourcards.vue?vue&type=script&lang=js"
export * from "./Fourcards.vue?vue&type=script&lang=js"

import "./Fourcards.vue?vue&type=style&index=0&id=bce5def6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bce5def6"]])

export default __exports__